var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.type)?_c('merch-collection',{attrs:{"items":_vm.items,"label":_vm.type.name}}):(_vm.type)?_c('p',[_vm._v("Sorry, there are currently no "+_vm._s(_vm.type.name))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }